import React from "react";
import { SCHOOL } from "@/lib/constants";
import { PageBanner } from "@/components/PageBanner";

const P = ({ children }) => <p className="text-slate-600 leading-relaxed mb-4">{children}</p>;
const H = ({ children }) => <h3 className="font-head font-bold text-navy text-xl mt-8 mb-2">{children}</h3>;

export const Privacy = () => (
  <div>
    <PageBanner title="Privacy Policy" />
    <section className="max-w-3xl mx-auto px-6 py-16">
      <P>B.R.Smart Kidz / Academy ("we", "our", "the school") respects your privacy and is committed to protecting the personal information you share with us through this website.</P>
      <H>Information We Collect</H>
      <P>We collect information you voluntarily provide through our enquiry, admission, contact and feedback forms — such as name, phone number, email, and details about the student. Fee payments are processed securely through our payment partner; we do not store your card details.</P>
      <H>How We Use It</H>
      <P>Your information is used solely to respond to enquiries, process admissions, communicate school updates, and improve our services. We never sell or rent your personal data to third parties.</P>
      <H>Data Security</H>
      <P>This website is served over a secure (SSL/HTTPS) connection. We take reasonable measures to safeguard your data against unauthorised access.</P>
      <H>Contact</H>
      <P>For any privacy-related queries, contact us at {SCHOOL.email} or {SCHOOL.landline}.</P>
    </section>
  </div>
);

export const Terms = () => (
  <div>
    <PageBanner title="Terms & Conditions" />
    <section className="max-w-3xl mx-auto px-6 py-16">
      <P>By accessing and using this website, you agree to the following terms and conditions.</P>
      <H>Use of Website</H>
      <P>The content on this website is for general information about B.R.Smart Kidz / Academy. While we strive to keep information accurate and up to date, details such as fees, dates and notices are subject to change without prior notice.</P>
      <H>Admissions & Fees</H>
      <P>Submission of an online admission form does not guarantee admission. Admission is subject to seat availability, document verification and school policy. Fees once paid are non-refundable except as per school policy.</P>
      <H>Online Payments</H>
      <P>Online fee payments are facilitated through a secure third-party payment gateway. The school is not responsible for issues arising from the payment provider. Please retain your payment confirmation.</P>
      <H>Intellectual Property</H>
      <P>All content, logos and images on this website are the property of B.R.Smart Kidz / Academy and may not be reproduced without permission.</P>
      <H>Contact</H>
      <P>Questions about these terms can be directed to {SCHOOL.email}.</P>
    </section>
  </div>
);
